import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmationModal(props) {
	const classes = useStyles();
	const handleClose = () => {
		props.setOpenAlert(false);
	};

	const confirmAction = () => {
		props.setConfirmAction();
		props.setOpenAlert(false);
	};

	return (
		<div>
			<Dialog
				PaperProps={{ style: { borderRadius: 45, padding: 20 } }}
				open={props.open}
				TransitionComponent={Transition}
				keepMounted
				onClose={handleClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle className={classes.title} id="alert-dialog-slide-title">
					Esta seguro de <br /> realizar esta acción?
				</DialogTitle>
				<DialogActions style={{ justifyContent: "center" }}>
					<Button className={classes.btnCancel} onClick={handleClose} variant="text">
						Cancelar
					</Button>
					<Button className={classes.btnConfirm} onClick={confirmAction} variant="text">
						Aceptar
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

const useStyles = makeStyles((theme) => ({
	title: {
		textAlign: "center",
		color: theme.palette.primary.main,
		"& h2": {
			fontWeight: "bold",
		},
	},
	btnCancel: {
		backgroundColor: theme.palette.secondary.main,
		color: "#FFF",
		borderRadius: 20.5,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	btnConfirm: {
		backgroundColor: theme.palette.primary.main,
		color: "#FFF",
		borderRadius: 20.5,
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
		},
	},
}));
